<template>
  <ResultCard
    :num-uri-string="numUriString"
    :result="result"
    :as-link="false"
  />
</template>

<script>
import ResultCard from "@/views/Home/Card/Result";

export default {
  name: "GpsCard",
  props: {
    numUriString: String,
    result: Object,
  },
  components: {
    ResultCard,
  },
};
</script>
